import React from "react";
import { Globe } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

// Segmented EN | HR toggle — no portal, always clickable, clearly bilingual.
export const LanguageSwitcher = ({ testid = "header-language-switcher" }) => {
  const { lang, setLang } = useLang();
  const langs = [
    { code: "en", label: "EN" },
    { code: "hr", label: "HR" },
  ];
  return (
    <div data-testid={testid} className="inline-flex items-center gap-1 rounded-full hairline px-1.5 py-1">
      <Globe className="h-3.5 w-3.5 text-muted-foreground ml-1" />
      {langs.map((l) => (
        <button key={l.code} data-testid={`lang-option-${l.code}`} onClick={() => setLang(l.code)}
          className={`px-2 py-0.5 rounded-full text-xs font-mono uppercase transition-colors ${lang === l.code ? "bg-cyanx text-[#04121a]" : "text-foreground/65 hover:text-foreground"}`}>
          {l.label}
        </button>
      ))}
    </div>
  );
};
